/**
 * Builds the "Cancelar mi cita" link sent in the confirmation email.
 * The form slug is appended as ?form= so the cancel page can apply the dealer override.
 * @param {{domain: string, idCita: string, idConcesionario: string, uuid: string, correo: string, cliente: string, formSlug?: string | null}} appointment
 * @returns {string}
 */
export const buildCancelAppointmentUrl = ({ domain, idCita, idConcesionario, uuid, correo, cliente, formSlug }) => {
  const encodedMail = encodeURI(correo.trim());
  const encodedCliente = encodeURI(cliente);
  const cancelUrl = `${domain}/audi-forms/citas-de-servicio/cancelar/${idCita}/${idConcesionario}/${uuid}/${encodedMail}/${encodedCliente}`;

  return formSlug ? `${cancelUrl}?form=${encodeURIComponent(formSlug)}` : cancelUrl;
};

/**
 * Returns the dealer privacy notice URL, or the default one when the dealer has no URLs.
 * @param {string[] | string | null | undefined} dealerUrls
 * @param {string} defaultPrivacyUrl
 * @returns {string}
 */
export const resolvePrivacyNoticeUrl = (dealerUrls, defaultPrivacyUrl) =>
  !dealerUrls || dealerUrls.length === 0 ? defaultPrivacyUrl : dealerUrls[1];
